// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2azv6","largestCol":"styles_largestCol__12cfq","smallestCol":"styles_smallestCol__2Y4ib"};